import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=2ebc818e&scoped=true&lang=pug&"
import script from "./SelectCourse.vue?vue&type=script&lang=js&"
export * from "./SelectCourse.vue?vue&type=script&lang=js&"
import style0 from "./SelectCourse.vue?vue&type=style&index=0&id=2ebc818e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc818e",
  null
  
)

export default component.exports